import { getConfig as baseGetConfig } from '@dr.pogodin/react-utils';

export const VALID_ENVIRONMENTS = ['development', 'production'] as const;

type EnvironmentT = typeof VALID_ENVIRONMENTS[number];

export type ConfigT = {
  // NOTE: This is automatically assigned by the backend server.
  CSRF: string;
  DOMAIN: string;
  ENVIRONMENT: EnvironmentT;
  FIREBASE: {
    API_KEY: string;
    APP_ID: string;
    AUTH_DOMAIN: string;
    MEASUREMENT_ID: string;
    PROJECT_ID: string;
    STORAGE_BUCKET: string;
  };
  GOOGLE_RECAPTCHA_PUBLIC_KEY: string;
  HTTP_SCHEMA: 'http://' | 'https://';
  SECRET?: {
    ADMIN_EMAIL: string;
    COOKIE_SIGNATURE: string;
    DEV_ENV_CREDENTIALS: string;
    GOOGLE_CLOUD_SERVICE_ACCOUNT_BASE64: string;
    MAILERSEND_API_KEY: string;
    MONGODB_URL: string;
    OPENAI_API_KEY: string;
    VIMEO_ACCESS_TOKEN: string;
  };
  SUPPORT_EMAIL: string;
  USE_FIREBASE_EMULATORS: boolean;
};

export const getConfig = baseGetConfig<ConfigT>;
